export type FcrCoreServiceAction = "start" | "stop" | "reset";

export type FcrCoreAction = "start" | "pause" | "reset" | "from_ocpp";

export type FcrCoreModuleKind = "live" | "mock" | "stub";
export type FcrCoreModuleGroup = "init" | "now" | "mock" | "standalone" | "not_yet";
export type FcrCoreModuleState = "running" | "paused" | "stopped";

export type FcrCoreModule = {
  id: string;
  label: string;
  group: FcrCoreModuleGroup;
  kind: FcrCoreModuleKind;
  state: FcrCoreModuleState;
  hint?: string;
  file?: string;
  last_error?: string | null;
  last_tick_at?: string | null;
  detail?: Record<string, unknown>;
  streams_monitor?: boolean;
};

export type FcrCoreService = {
  label?: string;
  running: boolean;
  state?: string | null;
  pid?: number | null;
  last_exit?: string | null;
  error?: string;
};

export type FcrCoreModulesSnapshot = {
  ts?: string | null;
  process?: string;
  pool?: number;
  loop?: "running" | "paused" | "stopped";
  running?: boolean;
  modules: FcrCoreModule[];
  mqtt_connected?: boolean;
  error?: string;
  service?: FcrCoreService;
};

export async function fetchFcrCoreModules(): Promise<FcrCoreModulesSnapshot> {
  const res = await fetch("/api/fcr-core/modules", { credentials: "same-origin" });
  const data = (await res.json().catch(() => ({}))) as FcrCoreModulesSnapshot & {
    error?: string;
  };
  if (!res.ok) {
    throw new Error(data.error || `fcr-core modules ${res.status}`);
  }
  return { ...data, modules: data.modules ?? [] };
}

export async function postFcrCoreService(action: FcrCoreServiceAction): Promise<FcrCoreService | undefined> {
  const res = await fetch("/api/fcr-core/service", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ action }),
  });
  const data = (await res.json().catch(() => ({}))) as {
    error?: string;
    service?: FcrCoreService;
  };
  if (!res.ok) {
    throw new Error(data.error || `fcr-core service ${res.status}`);
  }
  return data.service;
}

export async function postFcrCoreCmd(id: string, action: FcrCoreAction): Promise<void> {
  const res = await fetch("/api/fcr-core/cmd", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ id, action }),
  });
  const data = (await res.json().catch(() => ({}))) as { error?: string };
  if (!res.ok) {
    throw new Error(data.error || `fcr-core cmd ${res.status}`);
  }
}
